
import findIndex from './findIndex';

const DEFAULT_INITIAL_PERMISSIONS = ['ARCHIVE', 'UPDATE', 'READ'];
const shouldIncludeAsset = (assetIdToFind) => (asset) => {
  const { assetId } = asset;

  return assetId === assetIdToFind;
};

function mergeAssets(
assetsMap,
assets,
organisationId)
{
  const newAssets = assets ? assets.slice() : [];

  assetsMap.forEach((asset, assetId) => {
    if (!asset) {
      return;
    }

    if (asset.organisationId === organisationId && !newAssets.some(shouldIncludeAsset(assetId))) {
      const newAsset = {
        ...asset,
        permissions: DEFAULT_INITIAL_PERMISSIONS
      };
      newAssets.unshift(newAsset);
      return;
    }

    const index = findIndex(newAssets, assetId);

    if (!newAssets[index]) {return;}

    if (newAssets[index].organisationId !== organisationId) {
      newAssets.splice(index, 1);
      return;
    }

    if (newAssets[index].status !== asset.status && asset.status === 'UPLOADED') {
      newAssets.splice(index, 1, asset);
    }
  });

  return newAssets;
}

export default mergeAssets;